import { render, staticRenderFns } from "./TableMenuProduct.vue?vue&type=template&id=7dcc078c&scoped=true&"
import script from "./TableMenuProduct.vue?vue&type=script&lang=js&"
export * from "./TableMenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./TableMenuProduct.vue?vue&type=style&index=0&id=7dcc078c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc078c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VMenu})
